import React from 'react';

import { ROUTES } from '@/consts/routes';
import { Separator } from '@radix-ui/react-separator';
import { LogOut } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

interface UserMenuProps {
  handleLogout: () => void;
}

export const UserMenu: React.FC<UserMenuProps> = ({ handleLogout }) => {
  const { t } = useTranslation();

  return (
    <div className="text-sm font-normal text-white/85">
      <Link
        to={ROUTES.user.terms}
        className="hover:bg-primary-800 block rounded-sm px-3 py-1.5 font-normal text-white/85 transition-colors duration-150"
      >
        {t('header.userMenu.terms')}
      </Link>

      <Link
        to={ROUTES.user.privacy}
        className="hover:bg-primary-800 block rounded-sm px-3 py-1.5 font-normal text-white/85 transition-colors duration-150"
      >
        {t('header.userMenu.privacy')}
      </Link>

      <Separator orientation="horizontal" className="my-1 h-[1px] bg-white/10" />

      <div
        role="button"
        onClick={handleLogout}
        className="hover:bg-primary-800 flex cursor-pointer items-center rounded-sm px-3 py-1.5 font-normal text-white/85 transition-colors duration-150"
      >
        <LogOut className="mr-1 size-4" /> {t('header.userMenu.signOut')}
      </div>
    </div>
  );
};
